"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importDefault(require("styled-components"));
function DescriptionHeader(props) {
    const { onClose, titleText, icon, closeDescriptionButtonRef } = props;
    return ((0, jsx_runtime_1.jsxs)(StyledHeader, { children: [(0, jsx_runtime_1.jsx)(Title, { children: titleText }), (0, jsx_runtime_1.jsx)(ui_1.ToolBarBaseButton, { onClick: onClose, ref: closeDescriptionButtonRef, children: (0, jsx_runtime_1.jsx)(ui_1.Icon, { name: icon, width: 18, height: 18 }) })] }));
}
const StyledHeader = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 8px;
  height: 44;

  font-size: 20px;
  flex-shrink: 0;
`;
const Title = styled_components_1.default.h1 `
  font-size: 20px;
  margin: 0;
`;
exports.default = DescriptionHeader;
